import React from 'react'
import View from 'components/View'
import ProductCardRating from 'components/ProductCard/components/Rating'

/**
 * @param {ProductVariantCollection} productVariant
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarReviewRating ({ productVariant, isFromProductPage = false }) {
  return (
    <View className='quick-shop-product-sidebar-rating'>
      <ProductCardRating
        // Needed otherwise the DOM crashes
        key={productVariant.variant_id}
        rating={productVariant.review_info.rating}
        ratingCount={productVariant.review_info.rating_count}
        likedCount={productVariant?.product_fav_stats?.liked_count}
        superLikedCount={productVariant?.product_fav_stats?.super_liked_count}
        isQuickShop
        isFromProductPage={isFromProductPage}
      />
    </View>
  )
}
